module.exports = __webpack_public_path__ + "static/media/img-step2@2x.0be2aede.png";